import React, { useEffect } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

import { faFaceSadTear } from "@fortawesome/free-regular-svg-icons";

import NavBar from "../components/common/navBar";

import { useLanguage } from "../i18n/LanguageContext";

import "./styles/404.css";

const Notfound = () => {
	const { t, locale } = useLanguage();

	useEffect(() => {
		document.title = `404 | ${t("main.siteTitle")}`;
	}, [locale, t]);

	const message = t("notFound.message", {
		url: typeof window !== "undefined" ? window.location.href : "",
	});

	return (
		<React.Fragment>
			<div className="not-found page-content">
				<NavBar />
				<div className="content-wrapper">
					<div className="notfound-container">
						<div className="notfound-message">
							<div className="notfound-title">
								{t("notFound.title")}{" "}
								<FontAwesomeIcon icon={faFaceSadTear} />
							</div>
							<div className="not-found-message">{message}</div>
							<a href="/" className="not-found-link">
								{t("notFound.link")}
							</a>
						</div>
					</div>
				</div>
			</div>
		</React.Fragment>
	);
};

export default Notfound;
